import { validateNumericArray, validateShapesMatch } from '../utils/validation.js';
import { mean } from '../utils/stats.js';

export function meanAbsoluteError(yTrue, yPred) {
  validateNumericArray(yTrue, 'yTrue');
  validateNumericArray(yPred, 'yPred');
  validateShapesMatch([yTrue], [yPred], 'yTrue', 'yPred');

  const errors = yTrue.map((val, i) => Math.abs(val - yPred[i]));
  return mean(errors);
}

export function meanSquaredError(yTrue, yPred) {
  validateNumericArray(yTrue, 'yTrue');
  validateNumericArray(yPred, 'yPred');
  validateShapesMatch([yTrue], [yPred], 'yTrue', 'yPred');

  const errors = yTrue.map((val, i) => Math.pow(val - yPred[i], 2));
  return mean(errors);
}

export function rootMeanSquaredError(yTrue, yPred) {
  return Math.sqrt(meanSquaredError(yTrue, yPred));
}

export function r2Score(yTrue, yPred) {
  validateNumericArray(yTrue, 'yTrue');
  validateNumericArray(yPred, 'yPred');
  validateShapesMatch([yTrue], [yPred], 'yTrue', 'yPred');

  const yMean = mean(yTrue);

  let ssRes = 0;
  let ssTot = 0;

  for (let i = 0; i < yTrue.length; i++) {
    ssRes += Math.pow(yTrue[i] - yPred[i], 2);
    ssTot += Math.pow(yTrue[i] - yMean, 2);
  }

  if (ssTot === 0) {
    return 1.0;
  }

  return 1 - (ssRes / ssTot);
}

export function meanAbsolutePercentageError(yTrue, yPred) {
  validateNumericArray(yTrue, 'yTrue');
  validateNumericArray(yPred, 'yPred');
  validateShapesMatch([yTrue], [yPred], 'yTrue', 'yPred');

  const errors = yTrue.map((val, i) => {
    if (val === 0) {
      return Math.abs(yPred[i]);
    }
    return Math.abs((val - yPred[i]) / val);
  });

  return mean(errors) * 100;
}

export function maxError(yTrue, yPred) {
  validateNumericArray(yTrue, 'yTrue');
  validateNumericArray(yPred, 'yPred');
  validateShapesMatch([yTrue], [yPred], 'yTrue', 'yPred');

  const errors = yTrue.map((val, i) => Math.abs(val - yPred[i]));
  return Math.max.apply(null, errors);
}

export const mae = meanAbsoluteError;
export const mse = meanSquaredError;
export const rmse = rootMeanSquaredError;
export const r2 = r2Score;
export const mape = meanAbsolutePercentageError;
